import styled from '@emotion/styled';

import { mq } from '@/utility/mediaQuery';
import { defaultTheme } from '@/utility/theme';

export const EmptyText = styled.p(() =>
  mq({
    width: '100%',
    color: defaultTheme.text.gray,
    textAlign: 'center',
    margin: [
      `${defaultTheme.spacing.xxl} 0 40px`,
      `${defaultTheme.spacing.xxl} 0 40px`,
      '100px 0',
      '100px 0',
    ],
  }),
);
